import React, { useState, useContext, useEffect } from "react";
import {
  Collapse,
  Navbar as BootstrapNavbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import {
  SidebarToggler,
  useSidebarContext,
} from "@repoflow/components/sidebar-menu";
import _ from "lodash";
import { Link } from "react-router-dom";
import { useAccount } from "@repoflow/components/account";

const Context = React.createContext(null);

export const useNavbarContext = () => {
  return useContext(Context);
};

export const NavbarProvider = ({ children }) => {
  const [{ menu }, setState] = useState({ menu: [] });

  return (
    <Context.Provider
      value={{
        menu,
        init: (submenu) =>
          setState((state) => {
            return { menu: submenu };
          }),
        push: (submenu) =>
          setState((state) => {
            const mod = [...state.menu];
            mod.push(submenu);
            return { menu: mod };
          }),
        pop: () =>
          setState((state) => {
            const mod = [...state.menu];
            mod.pop();
            return { menu: mod };
          }),
      }}
    >
      {children}
    </Context.Provider>
  );
};

export const Navbar = ({ title, menu, external }) => {
  const account = useAccount();
  const navbar = useNavbarContext();
  const sidebar = useSidebarContext();

  const home = "/app"

  const [isOpen, setIsOpen] = useState(false);
  const toggleNavbar = () => setIsOpen(!isOpen);

  useEffect(() => {
    navbar.init(menu);
  }, []);

  if (!account) {
    return null;
  }

  return (
    <BootstrapNavbar color="dark" dark expand="md">
      {sidebar && <SidebarToggler />}
      {(external ? (
          <NavbarBrand href={home}>{title}</NavbarBrand>
        ) : (
          <NavbarBrand tag={Link} to={home}>
            {title}
          </NavbarBrand>
        ))}
      <NavbarToggler onClick={toggleNavbar} className="mr-2" />
      <Collapse isOpen={isOpen} navbar>
        <Nav className="mr-auto" navbar>
          {_.map(navbar.menu, (Item, idx) => (
            <Item key={idx} />
          ))}
        </Nav>

        <Nav navbar>
          <NavItem>
            {/* email, not username: no project's AccountFragment selects a
                username and the API has no such field, so this rendered an
                empty label next to the icon. */}
            <NavLink href="/app/account/">
              <i className="fa fa-user"></i> {account.user.email}
            </NavLink>
          </NavItem>
        </Nav>
      </Collapse>
    </BootstrapNavbar>
  );
};
